import { Globals } from '../../../modules/Globals';
import axios from 'axios';
import { ICaja } from '../../../interfaces/ICaja';
import { IInvoicingItem } from '@/interfaces/IInvoicingItem';

const apiUrl = Globals.apiPath + '/invoicing/item';

export default class InvoicingItemService {
  constructor() {}

  static async getOne(id: number): Promise<IInvoicingItem> {
    let res = await axios.get<IInvoicingItem>(`${apiUrl}/${id}`);
    return res.data;
  }
}
